export default  {
  bindings: {
    targetuser: '=',
    hotels: '<',
    access: '<',
    accessroles: '<',
    accessuserroles: '<',
    accessuserrules: '<',
    rules: '<',
    actions: '<',
    sections: '<',
    items: '<',
    title: '@'
  },
  controller: 'userSaveController',
  template: require('../views/user.save.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/user/components/user.save.component.js